export default "__VITE_ASSET__COmzKpBs__"